module.exports = __webpack_public_path__ + "img/couples_05_V.3ff1bd9c.webp";